import React, { useEffect, useState } from 'react';
import events from '../../../../events';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';
import AddIncident from './AddIncident';
import BtnStatus from '../status/BtnStatus';
import UpdateIncident from './UpdateIncident';

const IncidentTypes = (props) => {
    const { theme, locale, data, ModuleRP } = props; // setActivePage,
    const [addIncendent, setAddIncident] = useState(false);
    const [openUpdateIncident, setopenUpdateIncident] = useState(false);

    const addIncident = (incident) => {
        if (incident) ModuleRP.config.addIncident(incident);
        setAddIncident(false);
    };

    const updateIncident = (incident) => {
        if (!openUpdateIncident) {
            const selectedIncident = data.incidents.find((i) => i.id === incident);
            setopenUpdateIncident(selectedIncident);
        } else {
            if (incident) {
                const params = ['id', 'category', 'reason', 'place', 'responses', 'services'];
                const values = [incident.id, incident.category, incident.reason, incident.place, incident.responses, incident.services];
                ModuleRP.config.updateIncident(params, values);
            }
            setopenUpdateIncident(false);
        }
    };

    useEffect(() => {
        if (data.type !== 'game' || !ModuleRP.sigData) {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        }
    }, [data]);
    return (
        data.type === 'game' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">
                        {locales[locale].config.incidentTypes}
                    </h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        {
                            !addIncendent && !openUpdateIncident ? (
                                <button
                                    className="btn btn-primary btn-sm m-1 pl-3 pr-3"
                                    onClick={() => setAddIncident(true)}
                                >
                                    {locales[locale].config.add}
                                </button>
                            ) : (
                                addIncendent ? (
                                    <AddIncident
                                        addIncident={addIncident}
                                        locale={locale}
                                        theme={theme}
                                        data={data}
                                        sigData={ModuleRP.sigData}
                                    />
                                ) : (
                                    <UpdateIncident
                                        updateIncident={updateIncident}
                                        locale={locale}
                                        theme={theme}
                                        data={data}
                                        sigData={ModuleRP.sigData}
                                        incident={openUpdateIncident}
                                    />
                                )
                            )
                        }
                        {
                            !addIncendent && !openUpdateIncident && (
                                <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                    <thead>
                                        <tr>
                                            <th>{locales[locale].config.categories}</th>
                                            <th>{locales[locale].config.reasons}</th>
                                            <th>{locales[locale].config.places}</th>
                                            <th>{locales[locale].config.response}</th>
                                            <th>{locales[locale].config.services}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody id='incidentTypes'>
                                        {
                                            data.incidents && data.incidents.map((incidentType) => (
                                                <tr key={incidentType.id} id={incidentType.id}>
                                                    <td>{locales[locale].sga[incidentType.category]}</td>
                                                    <td>{incidentType.reason}</td>
                                                    <td>{locales[locale].sig[incidentType.place]}</td>
                                                    <td>
                                                        {incidentType?.responses?.map((r) => (
                                                            <div key={r._id} className="ml-2">
                                                                {
                                                                    r.function.split('||').map((f, i) => (
                                                                        i === 0 ? (
                                                                            <div key={i} className={`ml-2`}>
                                                                                <BtnStatus
                                                                                    listStatus={data.status}
                                                                                    code={9}
                                                                                    text={data.functions.find((func) => func.id === f).name}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div key={i} className={`ml-5`}>
                                                                                {
                                                                                    f.split('+').map((f2, i2) => (
                                                                                        <span key={i2}>
                                                                                            <BtnStatus
                                                                                                listStatus={data.status}
                                                                                                code={9}
                                                                                                text={
                                                                                                    data.functions.find((func) => func.id === f2)?.name ||
                                                                                                    '?'
                                                                                                }
                                                                                            />
                                                                                            {i2 < f.split('+').length - 1 && <span key={i2}>+</span>}
                                                                                        </span>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        )
                                                                    ))
                                                                }

                                                            </div>
                                                        ))}
                                                    </td>
                                                    <td>
                                                        {incidentType.services}
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            id={`btn-update-incident-${incidentType.id}`}
                                                            onClick={() => updateIncident(incidentType.id)}
                                                        >
                                                            {locales[locale].config.update}
                                                        </button>
                                                        <button
                                                            className="btn btn-danger btn-sm ml-1"
                                                            id={`btn-delete-incident-${incidentType.id}`}
                                                            onClick={() => ModuleRP.config.deleteIncident(incidentType.id)}
                                                        >
                                                            {locales[locale].delete}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            )
                        }
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default IncidentTypes;
